window.arApisKvkStatusFormatter = function(value, row) {
    if (value === 'success') {
        return '<span class="badge bg-success">' + __('Success') + '</span>';
    }
    if (value === 'error') {
        return '<span class="badge bg-danger">' + __('Error') + '</span>';
    }
    return value ? value : '';
};
